import gql from "graphql-tag";

export default gql`query Entity($id:Int!) {
    entity(id:$id) {
        id
        name
        typeid
        openid
        verificationTokenStatus
        verificationTokenSent
        archived
        type {
            id
            name
            contact
            security
            person
            company
            staff
            address
            groups
            employees
            allowMany
            entrySearchAllow
            entrySearchSearch
            entrySearchAdd
        }
        details {
            id
            body
            archived
            timestamp
            userid
            user {
                id
                name
            }
            detailtype {
                id
                name
            }
        }
        contactDetails
        devices {
            id
            typeid
            token
        }
        uploadEntities {
            id
            timestamp
            user {
                id
                name
            }
            uploadDescription {
                id
                body
            }
        }
        addressLink: addressLinkCurrent  {
            id
            addressid
            userid
            archived
            timestamp
            user {
                id
                name
            }
            address {
                id
                address
                wgs84latitude
                wgs84longitude
            }
        }
        addressLinks  {
            id
            addressid
            userid
            archived
            timestamp
            user {
                id
                name
            }
            address {
                id
                address
            }
        }
        gdpr {
            id
            agreed
            tokenEmail
        }
        userz {
            entityid
            username
            password
            userRoles {
                username
                rolename
            }
            userRepresentation
            version
        }
        federatedIdentityRepresentations
        emailSignature {
            id
            html
            htmlPromotion
            htmlWarnings
            text
            textPromotion
            textWarnings
        }
        personName
        dob: detailByArchived(typeid: 15) {
            id
            body
        }
        fee: detailByArchived(typeid: 14) {
            id
            body
        }
        group {
            id
            name
            groupPanels {
                id
                panelno
            }
        }
        relatedEntities {
            id
            name
        }
        relatedFiles {
            id
            referencelong
            categoryid
            departmentId : departmentid
            category {
                id
                shortname
            }
            subjectProperty
        }
        userRoles {
            username
            rolename
            version            
        }
        loginDetails {
            entityid
            groupid
            detailid
            loginEntity {
                entityid
                groupid
                username
                password
            }
            loginUser {
                entityid
                groupid
                username
                password
            }
            primary
            optout
            deny
        }
        teamsLeader {
            id
            code
            name
        }
        teamsMember {
            id
            code
            name
        }
        staff {
            id
            entityid
            branchid
            role
            departmentid
            feeearnerid
            printerid
            cashflowid
            convtool
            feeearner
            partner
            general
            complaints
            news
            photos
            admin
            helpdesk
            maintenance
            manager
            bills
            bodyaspect
            landregistry
            lrusername
            lrpassword
            archived
            timestamp
            version
            userid
            branch {
                id
                name
            }
            user { 
                id
                name
            }
        }
        companyEmployeeCompanies {
            id
            employee {
                id
                name
            }
        }
        companyEmployeeEmployees {
            id
            company {
                id
                name
            }
        }
        mortgagePanels {
            id
            branchid
            panelno
            branch {
                id
                name
            }            
        }
    }    
}`